// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sidebar-button {
  padding: 0;
  margin-bottom: 20px;
  width: 80%;
  height: 60px;
  display: flex;
  align-items: center;
  color: #8c8c8c;
  background-color: #fafafa;
  border: none;
  text-decoration: none;
  border-radius: 12px;
  transition: background-color linear 0.2s;
  cursor: pointer;
}

.sidebar-button:hover {
  background-color: #f0f0f0;
}

.active {
  background-color: #434c63;
  color: #ffffff;
  box-shadow: 3px 3px 5px #cccccc;
  transition: background-color linear 0.2s;
}

.active:hover {
  background-color: #7d8ab0;
}

.button-content {
  margin-left: 25px;
  display: flex;
  align-items: center;
}

.button_icon {
  margin-right: 20px;
}

.button-text {
  font-size: 18px;
}

@media screen and (max-width: 1050px) {
  .sidebar-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NavigationButtons/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".sidebar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.sidebar-button {\n  padding: 0;\n  margin-bottom: 20px;\n  width: 80%;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  color: #8c8c8c;\n  background-color: #fafafa;\n  border: none;\n  text-decoration: none;\n  border-radius: 12px;\n  transition: background-color linear 0.2s;\n  cursor: pointer;\n}\n\n.sidebar-button:hover {\n  background-color: #f0f0f0;\n}\n\n.active {\n  background-color: #434c63;\n  color: #ffffff;\n  box-shadow: 3px 3px 5px #cccccc;\n  transition: background-color linear 0.2s;\n}\n\n.active:hover {\n  background-color: #7d8ab0;\n}\n\n.button-content {\n  margin-left: 25px;\n  display: flex;\n  align-items: center;\n}\n\n.button_icon {\n  margin-right: 20px;\n}\n\n.button-text {\n  font-size: 18px;\n}\n\n@media screen and (max-width: 1050px) {\n  .sidebar-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
